export enum CategoryAssetTypeEnum {
  TRAITS = 'traits',
  OUTFITS = 'outfits',
  MIX_AND_MATCH_ITEMS = 'mix_and_match_items',
}
